import { ImagesHolder } from "../../image_loader/images_holder.js";
import { ImgID } from "../../image_loader/img_id.js";
import { CornerSizes, NineSliceDrawer } from "../../image_loader/nine_slicer/nine_slice_drawer.js";
import { SliceMode } from "../../types/nine_slice_interfaces.js";
import { snapToDevicePx } from "./dom_backend.js";

export interface INineSliceBorderImage
{
  key: string;
  url: string;
  slice: string;
  widths: string;
}

export function nineSliceBorderImage( img_id: ImgID, rule_key: string, w: number, h: number, sizes?: CornerSizes ): INineSliceBorderImage | null
{
  const url = ImagesHolder.getUrl( img_id );
  const caps = NineSliceDrawer.computeCaps( rule_key, w, h, sizes );
  if ( !url || !caps )
    return null;

  const rule = caps.rule;
  const px = ( v: number ) => `${snapToDevicePx( v )}px`;
  let slice: string;
  let widths: string;
  switch ( rule.slice_mode )
  {
    case SliceMode.HORIZONTAL:
      slice = `0 ${rule.image_width - rule.x2} 0 ${rule.x1}`;
      widths = `0px ${px( caps.tr_w )} 0px ${px( caps.tl_w )}`;
      break;
    case SliceMode.VERTICAL:
      slice = `${rule.y1} 0 ${rule.image_height - rule.y2} 0`;
      widths = `${px( caps.tl_h )} 0px ${px( caps.br_h )} 0px`;
      break;
    default:
      slice = `${rule.y1} ${rule.image_width - rule.x2} ${rule.image_height - rule.y2} ${rule.x1}`;
      widths = `${px( caps.tl_h )} ${px( caps.tr_w )} ${px( caps.br_h )} ${px( caps.tl_w )}`;
      break;
  }

  return { key: `${url}|${slice}|${widths}`, url, slice, widths };
}

export function applyNineSliceBorderImage( s: CSSStyleDeclaration, spec: INineSliceBorderImage ): void
{
  s.boxSizing = "border-box";
  s.borderStyle = "solid";
  s.borderColor = "transparent";
  s.borderWidth = spec.widths;
  s.borderImageSource = `url("${spec.url}")`;
  s.borderImageSlice = `${spec.slice} fill`;
  s.borderImageWidth = spec.widths;
  s.borderImageRepeat = "stretch";
}

export function styleAbsoluteLayer( el: HTMLElement ): void
{
  const s = el.style;
  s.position = "absolute";
  s.left = "0";
  s.top = "0";
  s.pointerEvents = "none";
}
